import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=66474698&"
import script from "./AppWidget.vue?vue&type=script&lang=js&"
export * from "./AppWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66474698')) {
      api.createRecord('66474698', component.options)
    } else {
      api.reload('66474698', component.options)
    }
    module.hot.accept("./AppWidget.vue?vue&type=template&id=66474698&", function () {
      api.rerender('66474698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widget/AppWidget.vue"
export default component.exports